import {StayPreference} from './stay-preference.model';

export class ReservationStayPreferences {
  stayPreferences: Array<StayPreference> = [];
  editable: boolean;
  optionsUnavailableMessage: string;
  optionsSavedMessage: string;
  notesMessage: string;
  saveMessage: string;
  resetMessage: string;
  footerMessage: string;
  userPreferenceSelected: boolean;
  saveToProfile: boolean;

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/stay-preferences/reservation-stay-preferences.model.ts